module.exports = __webpack_public_path__ + "img/pdca-do.58e3d25c.svg";